import { BottleTonicSkullIcon } from './BottleTonicSkullIcon';

/**
 * author: Michael Irigoyen
 * id CE430764-D7C8-4DC8-97F4-DF1473B2C52C
 * name bottle-tonic-skull
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-tonic-skull.svg
 * tags
 * - Gaming / RPG 
 * - Holiday 
 */
export const PoisonIcon = BottleTonicSkullIcon;
export default PoisonIcon